import {languageSelect, LanguageSelect} from "./language-select/LanguageSelectComponent";

export default function(parentModule: string): string {
    const moduleName = `${parentModule}.components`;

    return angular.module(moduleName, [])
                  .component(LanguageSelect, languageSelect())
                  .name;
}
